/* @flow */
import React from 'react';
import cx from 'classnames';

const CarouselPage = React.createClass({
  render() {
    return (
      <div
        {...this.props}
        className={cx('CarouselPage', this.props.className)}
      />
    );
  },
});

export default CarouselPage;



// WEBPACK FOOTER //
// ./src/components/CarouselPage.jsx